import axios from "axios";
import API_URL from "../config/env";

export const apiUrl = API_URL.apiUrl;

const defaultHeaders = {
  crossDomain: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json"
  }
};

const getConfigWithToken = (method = "GET", extraConfig = {}) => {
  const token = JSON.parse(localStorage.getItem('token'));
  return {
    ...defaultHeaders,
    method,
    headers: {
      ...defaultHeaders.headers,
      Authorization: token ? `Bearer ${token}` : undefined,
      ...extraConfig.headers
    },
    ...extraConfig
  };
};

export function getProductsRequest(pageNumber, perPage, search = "") {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}product_attributes/search`,
    data: {
      page: pageNumber,
      per_page: perPage,
      q: search
    }
  }).then((response) => response.data);
}

export function getCategoryRulesRequest(pageNumber, perPage, search = "") {
  return axios({
    ...getConfigWithToken("GET"),
    url: `${apiUrl}categories_rules?page=${pageNumber}&per_page=${perPage}`
  }).then((response) => response.data);
}

export function getListRoomsPermalinks(search = "") {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}rooms/permalinks`,
    data: {
      query: search
    }
  }).then((response) => response.data);
}

export function getListRoomVariantsPermalinks(search = "") {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}room_variants/permalinks`,
    data: {
      query: search
    }
  }).then((response) => response.data);
}

export function moveDesignRoomToDestinationRoomVariant(current_variant_id, destination_room_variant_id, from_design_room_id, furniture_ids) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}room_variants/copy_design_to_room_variant`,
    data: {
      current_variant_id,
      destination_room_variant_id,
      from_design_room_id,
      furniture_ids
    }
  }).then((response) => response.data);
}

export function checkEqualsDesignRoomRequest(design_room_id, room_variant_id) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}room_variants/check_equal_design_room`,
    data: {
      design_room_id,
      room_variant_id
    }
  }).then((response) => response.data);
}

export function updateDesignRoomPosition(design_room_id, room_variant_id, position) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}room_variants/update_design_room_position`,
    data: {
      design_room_id,
      room_variant_id,
      position
    }
  }).then((response) => response.data);
}

export function moveRoomVariantToDestinationRoom(design_rooms_ids, destination_room_id, move_room_variant_id) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}rooms/move`,
    data: {
      design_rooms_ids,
      destination_room_id,
      move_room_variant_id
    }
  }).then((response) => response.data);
}

export function checkEqualsDesignRoomsRequest(move_room_id, destination_room_id, room_variant_id) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}rooms/check_equals_design_rooms`,
    data: {
      move_room_id,
      destination_room_id,
      room_variant_id
    }
  }).then((response) => response.data);
}

export function getFiltersRequest() {
  return axios({
    ...getConfigWithToken("GET"),
    url: `${apiUrl}product_attributes/filter_options`
  }).then((response) => response.data);
}

export function postInputFilter(data) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}product_attributes/search`,
    data
  }).then((response) => response.data);
}

export function postAddAttribute(data) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}product_attributes`,
    data
  }).then((response) => response.data);
}

export function postAddRule(data) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}categories_rules`,
    data
  }).then((response) => response.data);
}

export function postCopyFurnitureItems(data) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}room_variants/copy_furniture`,
    data
  }).then((response) => response.data);
}

export function getAllMergeItems(type) {
  return axios({
    ...getConfigWithToken("GET"),
    url: `${apiUrl}${type}`
  }).then((response) => response.data);
}

export function getAllPurgeItems(type) {
  return axios({
    ...getConfigWithToken("GET"),
    url: `${apiUrl}${type}/purge_list`
  }).then((response) => response.data);
}

export function postAllMergeItems(type, parentId, childId) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}${type}/${parentId}/merge`,
    data: {
      child_id: childId
    }
  }).then((response) => response.data);
}

export function deletePurgeItems(ids, type) {
  return axios({
    ...getConfigWithToken("DELETE"),
    url: `${apiUrl}${type}`,
    data: {
      delete_ids: ids
    }
  }).then((response) => response.data);
}

export function postSearchAllMergeItems(type, text) {
  return axios({
    ...getConfigWithToken("POST"),
    url: `${apiUrl}${type}/search`,
    data: {
      q: text
    }
  }).then((response) => response.data);
}

export function getProductsByTypeId(type, id) {
  return axios({
    ...getConfigWithToken("GET"),
    url: `${apiUrl}${type}/${id}`
  }).then((response) => response.data);
}

export function updateRoomVariantActivity(id, type, value) {
  return axios({
    ...getConfigWithToken("PUT"),
    url: `${apiUrl}room_variant_activity/${id}`,
    data: { type, value }
  }).then((response) => response.data);
}
